<template>
  <div class="login-container">
    <h2>MIELOUPE ログイン</h2>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="userId">ユーザーID</label>
        <input
          type="text"
          v-model="userId"
          id="userId"
          :class="{ 'user-error-input': errors.userId }"
          required
        />
        <p v-if="errors.userId" class="user-error-message">{{ errors.userId }}</p>
      </div>
      <div class="form-group">
        <label for="password">パスワード</label>
        <input
          type="password"
          v-model="password"
          id="password"
          :class="{ 'user-error-input': errors.password }"
          required
        />
        <p v-if="errors.password" class="user-error-message">{{ errors.password }}</p>
      </div>
        <div class="form-group remember-me-label">
        <input type="checkbox" id="rememberMe" v-model="rememberMe" />
        <label for="rememberMe">ログイン情報を記憶する</label>
      </div>

      <button type="submit">ログイン</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userId: "",
      password: "",
      rememberMe: false,
      errors: {
        userId: "",
        password: "",
      },
    };
  },
created() {
    if (localStorage.getItem("rememberMe") === "true") {
      this.userId = localStorage.getItem("rememberedUserId") || "";
      this.password = localStorage.getItem("rememberedPassword") || "";
      this.rememberMe = true;
    }
  },
  methods: {
    updateRadioButtonState() {
      // デフォルトではすべてを有効に
      this.disabledStates = {
        systemAdmin: false,
        admin: false,
        other: false,
        visualizationMember: false,
      };
    },
    // validateInputs() {
    //   let isValid = true;

    //   // ユーザー名のバリデーション
    //   if (this.userId.length !== 8) {
    //     this.errors.userId = "ユーザーIDは8桁の英数字で入力してください。";
    //     isValid = false;
    //   } else if (!/^[a-zA-Z0-9]+$/.test(this.userId)) {
    //     this.errors.userId = "ユーザーIDは英数字で入力してください。";
    //     isValid = false;
    //   } else {
    //     this.errors.userId = "";
    //   }

    //   // パスワードのバリデーション
    //   if (this.password.length < 4 || this.password.length > 40) {
    //     this.errors.password = "パスワードは4桁以上40桁以下の英数字で入力してください。";
    //     isValid = false;
    //   } else if (!/^[a-zA-Z0-9]+$/.test(this.password)) {
    //     this.errors.password = "パスワードは英数字で入力してください。";
    //     isValid = false;
    //   } else {
    //     this.errors.password = "";
    //   }

    //   return isValid;
    // },
    async login() {
    console.log("ログインメソッドが呼び出されました"); // デバッグ用
    // if (!this.validateInputs()) {
    //   return;
    // }

    try {
      // サーバーに送信するデータ
      const data = {
        id: this.userId,
        password: this.password,
        withCredentials: true
      };

      // APIリクエスト送信
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/auth/login`,
        data
      );

      if (response.status === 200) {
        const { token, user} = response.data; // レスポンスデータからトークンとセクションIDを取得
        localStorage.setItem("jwtToken", token);
        localStorage.setItem("section", user.section);
        localStorage.setItem("userId", user.id);
        localStorage.setItem("regionId", user.region_id);
        localStorage.setItem("directAdminAgency", user.directAdmin_agency);

        // Remember Me機能の設定
        if (this.rememberMe) {
          localStorage.setItem("rememberedUserId", this.userId);
          localStorage.setItem("rememberedPassword", this.password);
          localStorage.setItem("rememberMe", true);
        } else {
          localStorage.removeItem("rememberedUserId");
          localStorage.removeItem("rememberedPassword");
          localStorage.removeItem("rememberMe");
        }
          console.log("ログイン成功", user);
          this.$router.push("/");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.errors.userId = "ユーザーIDまたはパスワードが正しくありません。";
          this.errors.password = "ユーザーIDまたはパスワードが正しくありません。";
        } else if (error.response && error.response.status === 500) {
          alert("サーバーエラーが発生しました。しばらくしてからお試しください。");
        } else {
          alert("ネットワークエラーが発生しました。接続を確認してください。");
        }
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  max-width: 350px;
  margin: 120px auto;
  padding: 30px;
  background-color: #d4f1c5; /* 全体の背景を明るい緑色に */
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

h2 {
  margin-bottom: 20px;
  color: #1e1e1e; /* Neutral Dark */
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #4d4d4d; /* Neutral */
  font-size: 14px;
  font-weight: 700;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #c8c8c8; /* Neutral Border */
  border-radius: 5px;
  font-size: 16px;
  line-height: 1.5;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

input[type="checkbox"] {
  width: auto; /* チェックボックスは幅を固定 */
  padding: 0;  /* 不要なパディングを取り除く */
  margin: 0;   /* 余分なマージンも取り除く */
}

input:focus {
  border-color: #276ef1; /* Primary Blue */
  outline: none;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #276ef1; /* Primary Blue */
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  cursor: pointer;
  transition: background-color 0.3s;
}

/* 新規登録ボタン */
.register-button {
  background-color: #4caf50; /* Registration Button Color */
  color: #ffffff;
  padding: 10px; /* 少し小さめに設定 */
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px; /* 上側にも少し余白 */
}

button:hover {
  background-color: #174ea6; /* Darker shade of Primary Blue */
}

.register-button:hover {
  background-color: #357a38; /* 新規登録ボタンのホバー時の色 */
}

.remember-me-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.remember-me-label input[type="checkbox"] {
  margin-right: 8px; /* チェックボックスとテキストの間のスペース */
}

/* エラーメッセージのスタイル */
.user-error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

/* エラー時の入力欄のスタイル */
.user-error-input {
  border: 2px solid red !important;
  background-color: #ffe6e6;
}
</style>
